import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2B2B = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/b2b2b-travel-portal-head.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2B2B Travel Portal
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2B2B Travel Portal
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					B2B2B Booking System
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2b2b-travel-portal.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2B2B Travel Portal System is suitable for those Travel Agencies
								whose want to do Travel Business with a big network in which
								agents as well as distributors can be add. Arya Aviation makes
								is possible to do your business at this level by using our B2B2B
								or Distributor Travel Software. The business model of B2B Travel
								Agency is different from retail or B2C business.
							</p>
							<br />
							<p>
								Online Travel Agency never keeps inventories in hand, rather
								options are searched based on client's request and booking is
								done at client confirmation. In B2C - Business to Customer
								model, clients can search and book the tickets and packages on
								the online travel portal. But in B2B2B -Business to business to
								business model, admin can give Travel Portal to distributors and
								agents to book tickets and packages.
							</p>
							<p>
								In our B2B2B Portal Master Agency can add Agents as well as
								Distributor from their Admin Panel. Admin can manage deals,
								mark-ups, discounts etc. for all distributors and agents. Like
								Admin distributor can also create and manage Agents under him.
								By doing this Distributor can also increase their business
								network and earn more revenue. After all As a master Agency
								Admin have complete control on both the modules B2B and B2B2B.
								There are some managements that only can be used by Admin to
								maintain their Brand value and make it reliable. Arya Aviation
								also have Readymade White Label B2B2B Travel portal at an
								affordable price. Our White Label Travel Portal is deliverable
								in single day, which means you are ready to on board your Travel
								Agency in a day.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default B2B2B;
